import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { AppService } from "src/app/app.service";
import { TrainingService } from "../../services/training.service";

@Component({ standalone: false,
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss", "../../../styles/font-awesome.scss"],
})
export class MenuComponent implements OnInit {
  public businessId: string;
  public currentRoute: string;
  public permission: boolean = false;

  constructor(
    public _router: Router,
    public _route: ActivatedRoute,
    public _appService: AppService,
    public _trainService: TrainingService
  ) {}

  ngOnInit(): void {
    this.currentRoute = this._router.url;

    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });
  }
}
